import FastIcon from '../../assets/svg/fast.svg?react';
import ProIcon from '../../assets/svg/pro.svg?react';
import UltraIcon from '../../assets/svg/ultra.svg?react';
import RatioIconAuto from '../../assets/svg/auto.svg?react';
import RatioIcon1 from '../../assets/svg/1-1.svg?react';
import RatioIcon2 from '../../assets/svg/2-3.svg?react';
import RatioIcon3 from '../../assets/svg/3-2.svg?react';
import RatioIcon4 from '../../assets/svg/4-5.svg?react';
import RatioIcon5 from '../../assets/svg/5-4.svg?react';
import RatioIcon6 from '../../assets/svg/9-16.svg?react';
import RatioIcon7 from '../../assets/svg/16-9.svg?react';
import RatioIcon43 from '../../assets/svg/4-3.svg?react';
import RatioIcon34 from '../../assets/svg/3-4.svg?react';
import RatioIcon219 from '../../assets/svg/21-9.svg?react';
import RatioIcon921 from '../../assets/svg/9-21.svg?react';
import FJTextToImageConfig from '../appConfig/FJTextToImageConfig';
import FJConfig from '../FJConfig';
import { TAGS, CATEGORIES } from '../../constants/FJModelAttributesConstant';

export const MODELS_VALUE = {
    GOOGLE_NANO_BANANA_PRO: 'google-nano-banana-pro',
    GOOGLE_NANO_BANANA: 'google-nano-banana',
    OPENAI_GPT_IMAGE_1: 'openai-gpt-image-1',
    OPENAI_GPT_IMAGE_1_5: 'openai-gpt-image-1.5',
    FLUX_SCHNELL: 'flux-schnell',
    GOOGLE_IMAGEN_4_ULTRA: 'google-imagen-4-ultra',
    GOOGLE_2_5_FLASH_IMAGE: 'google-2.5-flash-image',
    GOOGLE_IMAGEN_4: 'google-imagen-4',
    GOOGLE_IMAGEN_4_FAST: 'google-imagen-4-fast',
    FLUX_1_1_PRO_ULTRA: 'flux-1.1-pro-ultra',
    FLUX_1_1_PRO: 'flux-1.1-pro',
    FLUX_DEV: 'flux-dev',
    BYTEDANCE_SEEDREAM_3: 'bytedance-seedream-3.0',
    BYTEDANCE_SEEDREAM_4: 'bytedance-seedream-4',
    BYTEDANCE_SEEDREAM_4_5: 'bytedance-seedream-4.5',
    KLING_IMAGE_O1: 'kling-vo1',
    QWEN_IMAGE: 'qwen-image',
    HUNYUAN_IMAGE_3: 'hunyuan',
    FLUX_2_FLEX: 'flux-2-flex',
    FLUX_2_PRO: 'flux-2-pro',
};

export const IMAGE_MODEL_FILTERS = [
    { label: 'all', value: CATEGORIES.ALL },
    { label: '720p', value: CATEGORIES.P720 },
    { label: '1080p', value: CATEGORIES.P1080 },
    { label: '2k', value: CATEGORIES.K2 },
    { label: '4k', value: CATEGORIES.K4 },
    { label: 'reference', value: CATEGORIES.REFERENCE },
    { label: 'text-prompt', value: CATEGORIES.TEXT_PROMPT },
];

const FJTextToImageDataConfig = {
    V1_MODELS: [
        {
            name: 'fast',
            renderIcon: FastIcon,
            useCredit: 1,
            value: 'schnell',
            v2Model: MODELS_VALUE.FLUX_SCHNELL,
        },
        {
            name: 'pro',
            renderIcon: ProIcon,
            useCredit: 2,
            value: 'dev',
            v2Model: MODELS_VALUE.FLUX_DEV,
        },
        {
            name: 'ultra',
            icon: UltraIcon,
            useCredit: 3,
            value: 'pro',
            v2Model: MODELS_VALUE.FLUX_1_1_PRO,
        },
    ],
    MODELS: [
        {
            name: 'Google Nano Banana Pro',
            renderIcon: FJTextToImageConfig.modelIconPath + 'google.png' + `?v=${FJConfig.version}`,
            useCredit: 10,
            value: MODELS_VALUE.GOOGLE_NANO_BANANA_PRO,
            description: 'google-nano-banana-pro-desc',
            supportImageReference: true, // 是否支持图片参考
            supportImageReferenceNum: 10,
            supportStylePrompt: true, // 是否支持风格提示词
            supportRatios: ['auto', '1:1', '2:3', '3:2', '3:4', '4:3', '4:5', '5:4', '9:16', '16:9', '21:9'],
            supportResolutions: [
                {
                    name: '1K <span>(1080px)</span>',
                    value: '1K',
                },
                {
                    name: '2K <span>(2048px)</span>',
                    value: '2K',
                },
                {
                    name: '4K <span>(4096px)</span>',
                    value: '4K',
                },
            ],
            creditPriceLevels: {
                '1K': 12,
                '2K': 14,
                '4K': 16,
            },
            needTranslate: false,
            categorys: [CATEGORIES.P1080, CATEGORIES.K2, CATEGORIES.K4, CATEGORIES.REFERENCE, CATEGORIES.TEXT_PROMPT],
            tags: [TAGS.K4, TAGS.REFERENCE, TAGS.TEXT_PROMPT],
        },
        {
            name: 'OpenAI GPT Image 1.5',
            renderIcon: FJTextToImageConfig.modelIconPath + 'openai.png' + `?v=${FJConfig.version}`,
            useCredit: 6,
            value: MODELS_VALUE.OPENAI_GPT_IMAGE_1_5,
            description: 'openai-gpt-image-1.5-desc',
            supportImageReference: true,
            supportImageReferenceNum: 10,
            supportStylePrompt: true,
            supportRatios: ['1:1', '2:3', '3:2'],
            supportResolutionsTitle: 'quality',
            supportResolutions: [
                {
                    name: 'low',
                    value: 'low',
                },
                {
                    name: 'medium',
                    value: 'medium',
                },
                {
                    name: 'high',
                    value: 'high',
                },
            ],
            creditPriceLevels: {
                low: 6,
                medium: 8,
                high: 10,
            },
            maxImagesPerRequest: 4, // 单次最多生成4张
            needTranslate: false,
            isNew: true,
            categorys: [CATEGORIES.P1080, TAGS.REFERENCE, TAGS.TEXT_PROMPT],
            tags: [TAGS.P1080, TAGS.REFERENCE, TAGS.TEXT_PROMPT],
        },
        {
            name: 'Bytedance Seedream 4.5',
            renderIcon: FJTextToImageConfig.modelIconPath + 'byte.png' + `?v=${FJConfig.version}`,
            useCredit: 4,
            value: MODELS_VALUE.BYTEDANCE_SEEDREAM_4_5,
            description: 'bytedance-seedream-4.5-desc',
            supportImageReferenceNum: 10,
            supportImageReference: true,
            supportStylePrompt: true,
            supportRatios: ['1:1', '4:3', '3:4', '16:9', '9:16', '3:2', '2:3', '21:9'],
            needTranslate: false,
            // supportResolutions: [
            //     {
            //         name: '2K <span>(2048px)</span>',
            //         value: '2K',
            //     },
            //     {
            //         name: '4K <span>(4096px)</span>',
            //         value: '4K',
            //     },
            // ],
            categorys: [CATEGORIES.K2, CATEGORIES.K4, CATEGORIES.REFERENCE, CATEGORIES.TEXT_PROMPT],
            tags: [TAGS.K4, TAGS.REFERENCE, TAGS.TEXT_PROMPT],
        },
        {
            name: 'Kling Image O1',
            renderIcon: FJTextToImageConfig.modelIconPath + 'kling.png' + `?v=${FJConfig.version}`,
            useCredit: 3,
            value: MODELS_VALUE.KLING_IMAGE_O1,
            description: 'kling-image-o1-desc',
            supportImageReference: true,
            supportImageReferenceNum: 10,
            supportStylePrompt: true,
            supportRatios: ['16:9', '9:16', '1:1', '4:3', '3:4', '3:2', '2:3', '21:9'],
            needTranslate: false,
            isNew: true,
            supportResolutions: [
                {
                    name: '1K <span>(1024px)</span>',
                    value: '1K',
                },
                {
                    name: '2K <span>(2048px)</span>',
                    value: '2K',
                },
            ],
            creditPriceLevels: {
                '1K': 3,
                '2K': 3,
            },
            promptCharacterLimit: 2500,
            categorys: [CATEGORIES.K2, TAGS.REFERENCE],
            tags: [TAGS.K2, TAGS.REFERENCE],
        },
        {
            name: 'Flux 2 Pro',
            renderIcon: FJTextToImageConfig.modelIconPath + 'flux.png' + `?v=${FJConfig.version}`,
            useCredit: 2,
            value: MODELS_VALUE.FLUX_2_PRO,
            description: 'flux-2-pro-desc',
            supportRatios: ['1:1', '16:9', '3:2', '2:3', '4:5', '5:4', '9:16', '3:4', '4:3'],
            supportImageReferenceNum: 6,
            needTranslate: false,
            supportImageReference: true,
            supportStylePrompt: true,
            categorys: [CATEGORIES.P1080, TAGS.REFERENCE],
            tags: [TAGS.P1080, TAGS.REFERENCE],
        },
        {
            name: 'Hunyuan Image 3',
            renderIcon: FJTextToImageConfig.modelIconPath + 'hunyuan.png' + `?v=${FJConfig.version}`,
            useCredit: 8,
            value: MODELS_VALUE.HUNYUAN_IMAGE_3,
            description: 'hunyuan-image-3-desc',
            supportImageReference: false,
            supportRatios: ['1:1', '16:9', '9:16', '2:3', '3:2', '4:3', '3:4', '4:5', '5:4', '21:9', '9:21'],
            supportStylePrompt: true,
            needTranslate: false,
            categorys: [CATEGORIES.P1080, TAGS.TEXT_PROMPT],
            tags: [TAGS.P1080, TAGS.TEXT_PROMPT],
        },
        {
            name: 'Qwen Image',
            renderIcon: FJTextToImageConfig.modelIconPath + 'alibaba.png' + `?v=${FJConfig.version}`,
            useCredit: 3,
            value: MODELS_VALUE.QWEN_IMAGE,
            description: 'qwen-image-desc',
            supportImageReference: false,
            supportStylePrompt: true,
            supportRatios: ['1:1', '16:9', '9:16', '2:3', '3:2', '4:3', '3:4'],
            needTranslate: false,
            categorys: [CATEGORIES.P1080, TAGS.TEXT_PROMPT],
            tags: [TAGS.P1080, TAGS.TEXT_PROMPT],
        },
        {
            name: 'Google Nano Banana',
            renderIcon: FJTextToImageConfig.modelIconPath + 'google.png' + `?v=${FJConfig.version}`,
            useCredit: 4,
            value: MODELS_VALUE.GOOGLE_NANO_BANANA,
            description: 'google-nano-banana-desc',
            supportImageReferenceNum: 5,
            supportImageReference: true, // 是否支持图片参考
            supportStylePrompt: true, // 是否支持风格提示词
            supportRatios: null,
            needTranslate: false,
            categorys: [CATEGORIES.P1080, TAGS.REFERENCE],
            tags: [TAGS.P1080, TAGS.REFERENCE],
        },
        {
            name: 'Google Imagen 4 Ultra',
            renderIcon: FJTextToImageConfig.modelIconPath + 'google.png' + `?v=${FJConfig.version}`,
            useCredit: 6,
            value: MODELS_VALUE.GOOGLE_IMAGEN_4_ULTRA,
            description: 'google-imagen-4-ultra-desc',
            supportImageReference: false,
            supportRatios: ['1:1', '16:9', '9:16', '4:3', '3:4'],
            supportStylePrompt: true,
            needTranslate: false,
            categorys: [CATEGORIES.P1080, TAGS.TEXT_PROMPT],
            tags: [TAGS.P1080, TAGS.TEXT_PROMPT],
        },
        // {
        //     name: 'Google-2.5-Flash-Image',
        //     renderIcon: FJTextToImageConfig.modelIconPath + 'google.png' + `?v=${FJConfig.version}`,
        //     useCredit: 8,
        //     value: MODELS_VALUE.GOOGLE_2_5_FLASH_IMAGE,
        //     description: 'google-2-5-flash-image-desc',
        //     supportImageReference: false,
        //     supportStylePrompt: true,
        //     supportRatios: null,
        //     needTranslate: false,
        // },
        {
            name: 'Google Imagen 4',
            renderIcon: FJTextToImageConfig.modelIconPath + 'google.png' + `?v=${FJConfig.version}`,
            useCredit: 4,
            value: MODELS_VALUE.GOOGLE_IMAGEN_4,
            description: 'google-imagen-4-desc',
            supportImageReference: false,
            supportStylePrompt: true,
            supportRatios: ['1:1', '16:9', '9:16', '4:3', '3:4'],
            needTranslate: false,
            categorys: [CATEGORIES.P1080, TAGS.TEXT_PROMPT],
            tags: [TAGS.P1080, TAGS.TEXT_PROMPT],
        },
        {
            name: 'Google Imagen 4 Fast',
            renderIcon: FJTextToImageConfig.modelIconPath + 'google.png' + `?v=${FJConfig.version}`,
            useCredit: 2,
            value: MODELS_VALUE.GOOGLE_IMAGEN_4_FAST,
            description: 'google-imagen-4-fast-desc',
            supportImageReference: false,
            supportStylePrompt: true,
            supportRatios: ['1:1', '16:9', '9:16', '4:3', '3:4'],
            needTranslate: false,
            categorys: [CATEGORIES.P1080, TAGS.TEXT_PROMPT],
            tags: [TAGS.P1080, TAGS.FAST, TAGS.TEXT_PROMPT],
        },
        {
            name: 'OpenAI GPT Image 1',
            renderIcon: FJTextToImageConfig.modelIconPath + 'openai.png' + `?v=${FJConfig.version}`,
            useCredit: 4,
            value: MODELS_VALUE.OPENAI_GPT_IMAGE_1,
            description: 'openai-gpt-image-1-desc',
            supportImageReferenceNum: 5,
            supportImageReference: true,
            supportStylePrompt: true,
            supportRatios: ['1:1', '2:3', '3:2'],
            needTranslate: false,
            categorys: [CATEGORIES.P1080, TAGS.REFERENCE],
            tags: [TAGS.P1080, TAGS.REFERENCE],
        },
        {
            name: 'Flux 2 Flex',
            renderIcon: FJTextToImageConfig.modelIconPath + 'flux.png' + `?v=${FJConfig.version}`,
            useCredit: 6,
            value: MODELS_VALUE.FLUX_2_FLEX,
            description: 'flux-2-flex-desc',
            supportImageReferenceNum: 10,
            supportImageReference: true,
            supportStylePrompt: true,
            supportRatios: ['1:1', '16:9', '3:2', '2:3', '4:5', '5:4', '9:16', '3:4', '4:3'],
            needTranslate: false,
            categorys: [CATEGORIES.P1080, TAGS.REFERENCE],
            tags: [TAGS.P1080, TAGS.FAST, TAGS.REFERENCE],
        },
        {
            name: 'Flux 1.1 Pro',
            renderIcon: FJTextToImageConfig.modelIconPath + 'flux.png' + `?v=${FJConfig.version}`,
            useCredit: 4,
            value: MODELS_VALUE.FLUX_1_1_PRO,
            description: 'flux-1-1-pro-desc',
            supportImageReference: false,
            supportStylePrompt: true,
            supportRatios: ['1:1', '16:9', '9:16', '2:3', '3:2', '4:5', '5:4'],
            needTranslate: true,
            categorys: [CATEGORIES.P1080],
            tags: [TAGS.P1080],
        },
        {
            name: 'Flux Schnell',
            renderIcon: FJTextToImageConfig.modelIconPath + 'flux.png' + `?v=${FJConfig.version}`,
            useCredit: 1,
            value: MODELS_VALUE.FLUX_SCHNELL,
            description: 'flux-schnell-desc',
            supportImageReference: false,
            supportStylePrompt: true,
            supportRatios: ['1:1', '16:9', '9:16', '2:3', '3:2', '4:5', '5:4'],
            needTranslate: true,
            categorys: [CATEGORIES.P1080],
            tags: [TAGS.P1080, TAGS.FAST],
        },
        {
            name: 'Flux Dev',
            renderIcon: FJTextToImageConfig.modelIconPath + 'flux.png' + `?v=${FJConfig.version}`,
            useCredit: 3,
            value: MODELS_VALUE.FLUX_DEV,
            description: 'flux-dev-desc',
            supportImageReference: false,
            supportStylePrompt: true,
            supportRatios: ['1:1', '16:9', '9:16', '2:3', '3:2', '4:5', '5:4'],
            needTranslate: true,
            categorys: [CATEGORIES.P720],
            tags: [TAGS.P720, TAGS.FAST],
        },
        // {
        //     name: 'Flux-1.1-Pro-Ultra',
        //     renderIcon: FJTextToImageConfig.modelIconPath + 'flux.png' + `?v=${FJConfig.version}`,
        //     useCredit: 10,
        //     value: MODELS_VALUE.FLUX_1_1_PRO_ULTRA,
        //     description: 'flux-1-1-pro-ultra-desc',
        //     supportImageReference: false,
        //     supportStylePrompt: true,
        //     supportRatios: ['1:1', '16:9', '9:16', '2:3', '3:2', '4:3', '3:4', '4:5', '5:4'],
        //     needTranslate: true,
        // },
        {
            name: 'Bytedance Seedream 4',
            renderIcon: FJTextToImageConfig.modelIconPath + 'byte.png' + `?v=${FJConfig.version}`,
            useCredit: 6,
            value: MODELS_VALUE.BYTEDANCE_SEEDREAM_4,
            description: 'bytedance-seedream-4-desc',
            supportImageReferenceNum: 5,
            supportImageReference: true,
            supportStylePrompt: true,
            supportRatios: ['1:1', '16:9', '9:16', '2:3', '3:2', '4:3', '3:4'],
            needTranslate: false,
            isNew: false,
            categorys: [CATEGORIES.P1080, CATEGORIES.K2, CATEGORIES.K4, CATEGORIES.REFERENCE],
            tags: [TAGS.K4, TAGS.REFERENCE],
        },
        {
            name: 'Bytedance Seedream 3',
            renderIcon: FJTextToImageConfig.modelIconPath + 'byte.png' + `?v=${FJConfig.version}`,
            useCredit: 3,
            value: MODELS_VALUE.BYTEDANCE_SEEDREAM_3,
            description: 'bytedance-seedream-3-desc',
            supportImageReference: false,
            supportStylePrompt: true,
            supportRatios: ['1:1', '16:9', '9:16', '2:3', '3:2', '4:3', '3:4', '21:9'],
            needTranslate: false,
            categorys: [CATEGORIES.P720, TAGS.TEXT_PROMPT],
            tags: [TAGS.P720, TAGS.TEXT_PROMPT],
        },
    ],
    RATIO_LIST: [
        {
            name: 'auto',
            value: 1,
            renderIcon: RatioIconAuto,
        },
        {
            name: '1:1',
            value: 1,
            renderIcon: RatioIcon1,
        },
        {
            name: '16:9',
            value: 16 / 9,
            renderIcon: RatioIcon7,
        },
        {
            name: '9:16',
            value: 9 / 16,
            renderIcon: RatioIcon6,
        },
        {
            name: '2:3',
            value: 2 / 3,
            renderIcon: RatioIcon2,
        },
        {
            name: '3:2',
            value: 3 / 2,
            renderIcon: RatioIcon3,
        },
        {
            name: '4:3',
            value: 4 / 3,
            renderIcon: RatioIcon43,
        },
        {
            name: '3:4',
            value: 3 / 4,
            renderIcon: RatioIcon34,
        },
        {
            name: '4:5',
            value: 4 / 5,
            renderIcon: RatioIcon4,
        },
        {
            name: '5:4',
            value: 5 / 4,
            renderIcon: RatioIcon5,
        },
        {
            name: '21:9',
            value: 21 / 9,
            renderIcon: RatioIcon219,
        },
        {
            name: '9:21',
            value: 9 / 21,
            renderIcon: RatioIcon921,
        },
    ],

    IMAGE_NUMBER_LIST: [
        {
            value: 1,
            text: '1',
        },
        {
            value: 2,
            text: '2',
        },
        {
            value: 3,
            text: '3',
        },
        {
            value: 4,
            text: '4',
        },
    ],

    PROMPT_TEXT_LIMIT: 5000,
    PROMPT_PLACEHOLDER: 'text-to-image-prompt-desc',
};

export default FJTextToImageDataConfig;
